import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow, Typography, TableSortLabel } from "@material-ui/core"
import React from 'react';
import LinhaAmostras from './LinhaAmostras';
import MensagemListagemVazia from "../../../shared/components/MensagemListagemVazia";
import { LISTAGEM_VAZIA_FILTROS } from "../../../shared/utils/Constantes";

const ListaAmostras = ({ listaAmostras, handleOrdenacao, ordemDecrescente, handleArquivosAmostra }) => {

	const classes = useStyles()
	return (
		<>
			<Table stickyHeader size={"small"} className={classes.root}>
				<TableHead>
					<TableRow className={classes.header}>
						<TableCell className={classes.colunaCodigo} size={"small"} align="left">
							<Typography variant={"body2"}>Amostra</Typography>
						</TableCell>
						<TableCell className={classes.colunaNumeroLote} size={"small"} align="left">
							<Typography variant={"body2"}>Nº do lote</Typography>
						</TableCell>
						<TableCell className={classes.colunaTipoAmostra} size={"small"} align="left">
							<Typography variant={"body2"}>Tipo</Typography>
						</TableCell>
						<TableCell padding="none" />
						<TableCell className={classes.colunaConservacao} size={"small"} align="left">
							<Typography variant={"body2"}>Conservação</Typography>
						</TableCell>
						<TableCell className={classes.colunaPedido} size={"small"} align="left">
							<Typography variant={"body2"}>Pedido</Typography>
						</TableCell>
						<TableCell padding="none" />
						<TableCell className={classes.colunaPaciente} size={"small"} align="left">
							<Typography variant={"body2"}>Paciente</Typography>
						</TableCell>
						<TableCell padding="none" />
						<TableCell className={classes.colunaStatus} size={"small"} align="left">
							<Typography variant={"body2"}>Status</Typography>
						</TableCell>
						<TableCell padding="none" />
						<TableCell className={classes.colunaDataCadastro} size={"small"} align="left">
							<TableSortLabel
								active={true}
								direction={ordemDecrescente ? 'desc' : 'asc'}
								onClick={handleOrdenacao}
							>
								<Typography variant={"body2"}>Data Cadastro</Typography>
							</TableSortLabel>

						</TableCell>
						<TableCell className={classes.colunaAcoes} size={"small"} align="left">
							<Typography variant={"body2"}>Anexos</Typography>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{listaAmostras && listaAmostras.map((item, index) => (
						<LinhaAmostras
							key={item.codigo + index.toString()}
							item={item}
							index={index}
							handleArquivosAmostra={handleArquivosAmostra}
						/>
					))}
				</TableBody>
			</Table>
			{
				listaAmostras && listaAmostras.length === 0 &&
				<MensagemListagemVazia
					mensagem={LISTAGEM_VAZIA_FILTROS}
				/>
			}
		</>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		width: "99%",
		"& #form": {
			left: "-52px",
		},
		"& #form > div > div": {
			boxShadow: "none",
			borderStyle: "none",
		},
		"& .MuiBadge-root": {
			width: "5px",
		},
	},

	header: {
		height: "7vh",
	},

	fontRowHeader: {
		fontSize: "16px",
	},
	colunaCodigo: { width: "150px" },
	colunaNumeroLote: { width: "214px" },
	colunaTipoAmostra: { width: "120px" },
	colunaConservacao: { width: "150px" },
	colunaPedido: { width: "140px" },
	colunaPaciente: { width: "150px" },
	colunaStatus: { width: "170px" },
	colunaDataCadastro: { width: "250px" },
	colunaAcoes: { width: "40px" }
}))

export default ListaAmostras;